module.exports = __webpack_public_path__ + "img/nature_zitrone_2_big_new.f188d056.png";